import { Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import ModalComp from "./ModalComp";

export default function MoreEtcPoint({ children }) {
  const slideData = [
    {
      title: "강사평가",
      content:
        "수업에 참여하고 수업이 끝난 뒤 강사 평가에 참여하여 50 포인트를 획득할 수 있습니다.",
      img: "etc_point_1.png",
    },
    {
      title: "생일선물",
      content:
        "생일 날 두써킷에서 드리는 생일 선물로 5%할인쿠폰을 획득할 수도 있습니다.",
      img: "etc_point_2.png",
    },
    // { title: "강의평가", content: "수업에 참여하고 수업이 끝난 뒤 강의 평가에 참여하여 50 포인트를 획득할 수 있습니다.", img: "" },
  ];
  return (
    <div>
      <ModalComp button={children} fullScreen title="기타포인트" divider>
        <Swiper
          grabCursor={true}
          slidesPerView={1}
          className="mySwiper"
          pagination={{ clickable: true }}
          style={{
            width: "100%",
            height: "100%",
            zIndex: "1",
          }}
        >
          {slideData.map((data, index) => (
            <SwiperSlide
              key={index}
              className="flex flex-col items-center pb-10"
            >
              <p className="text-xl opacity-80 text-center mt-5">
                {data.title}
              </p>
              <p className="p-[20px_40px_40px_40px] text-[14px]">
                {data.content}
              </p>
              <img src={`/img/${data.img}`} alt="" className="w-[80%]" />
            </SwiperSlide>
          ))}
        </Swiper>
      </ModalComp>
    </div>
  );
}
